export default __webpack_public_path__ + "static/media/postgres.f7e09d17.svg";